import { render, staticRenderFns } from "./NewUserForm.vue?vue&type=template&id=5d2c8302&scoped=true&lang=pug&"
import script from "./NewUserForm.vue?vue&type=script&lang=js&"
export * from "./NewUserForm.vue?vue&type=script&lang=js&"
import style0 from "./NewUserForm.vue?vue&type=style&index=0&id=5d2c8302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c8302",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VForm,VRow,VSelect,VTextField,VTextarea})
